import React from "react";
import { useTabContext } from "../context/context";

const UploadError = () => {
  const { uploadError, setUploadError } = useTabContext();

  if (!uploadError) return null;

  return (
    <div className="w-full flex flex-col items-center border border-red-500 bg-red-200 my-4 p-2">
      <p>Upload Error: {uploadError}</p>
      <button type="button" className="bg-red-500 text-white px-4 py-1 rounded mt-2" onClick={() => setUploadError("")}>
        Dismiss
      </button>
    </div>
  );
};

export default UploadError;
